import { Component, QueryList, ViewChildren } from "@angular/core";
import {
  Platform,
  IonRouterOutlet,
  ToastController,
  AlertController,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { ApiService } from "./services/api.service";
import { UtilService } from "./services/util.service";
import { OneSignal } from "@ionic-native/onesignal/ngx";
import { TranslateService } from "@ngx-translate/core";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { jhcassoAPIUri } from "src/environments/apiUrl";
import { ProfileInfoResponse } from "./model/Response/ProfileData";
import { GeoLocationService } from "./geo-location-service.service";
import { AppVersion } from '@ionic-native/app-version/ngx';
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  public selectedIndex = 0;
  appVersion: string;
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  testString: string;
  constructor(
    private platform: Platform,
    private router: Router,
    private splashScreen: SplashScreen,
    private api: ApiService,
    private util: UtilService,
    private oneSignal: OneSignal,
    private translate: TranslateService,
    private statusBar: StatusBar,
    private toastController: ToastController,
    private alertCtrl: AlertController,
    public geoLocationService: GeoLocationService,
    private appVersionService: AppVersion
  ) {
    this.initializeApp();
    this.backButtonEvent();

    this.translate.setDefaultLang("en");
    localStorage.setItem("lan", "en");
    document.documentElement.dir = "ltr";
  }

  ngOnInit(): void {
    const theme = localStorage.getItem("theme") || "light";
    document.body.setAttribute("data-theme", theme);
  }


  initializeApp() {
    this.platform.ready().then(() => {
      setTimeout(() => this.splashScreen.hide(), 2000);
      this.statusBar.styleDefault();
      this.statusBar.backgroundColorByHexString("#E06287");
      this.geoLocationService.checkLocationPermission(); // Now this works

      this.appVersionService.getVersionNumber().then(version => {
        this.appVersion = version;
        console.log("App Version:", this.appVersion);
        localStorage.setItem("appVersion", this.appVersion);
      }).catch(error => {
        localStorage.setItem("appVersion", "Error retrieving app version " + error);
      });

      this.api.get(jhcassoAPIUri.appsetting).subscribe((response: any) => {
        if (response.status) {
          localStorage.setItem("currency_symbol", response.data.currencySymbol);
          localStorage.setItem("lat", response.data.lat);
          localStorage.setItem("lang", response.data.lang);
          localStorage.setItem("appSettingInfo", JSON.stringify(response.data));
          //this.util.setAppSettingInfo(response.data);
          this.initializeOneSignal(response.data);

          // this.oneSignal.startInit(
          //   response.data.ownerAppId,
          //   response.data.projectNo
          // );
          // this.oneSignal.getIds().then((token) => {
          //   localStorage.setItem("pushToken", token.userId);
          //   localStorage.setItem("deviceToken", token.userId);
          // });
          // this.oneSignal.endInit();
          // this.excuteOneSignalToGetToken(ownerAppId,projectNo);
        }
      });
    });

    if (this.api.IsLogged()) {
      this.api
        .get(jhcassoAPIUri.userprofile)
        .subscribe((profileResponse: ProfileInfoResponse) => {
          if (profileResponse.status) {
            this.util.profileData = profileResponse.data;
          }
        });
    }
  }

  backButtonEvent() {
    this.platform.backButton.subscribe(async () => {
      this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
        if (outlet && outlet.canGoBack()) {
          outlet.pop();
        } else if (
          this.router.url === "/tabs/calendar" ||
          this.router.url === "/tabs/sales" ||
          this.router.url === "/tabs/clients" ||
          this.router.url === "/tabs/notification" ||
          this.router.url === "/tabs/more" ||
          this.router.url === "/signin" ||
          this.router.url === "signin" ||
          this.router.url === "/subscription" ||
          this.router.url === "subscription"
        ) {
          if (
            new Date().getTime() - this.lastTimeBackPress <
            this.timePeriodToExit
          ) {
            navigator["app"].exitApp();
          } else {
            this.showToast();
            this.lastTimeBackPress = new Date().getTime();
          }
        }
      });
    });
  }

  initializeOneSignal(response) {
    // Start OneSignal initialization
    this.oneSignal.startInit(response.ownerAppId, response.projectNo);

    // Handle OneSignal event listeners here if needed (e.g., notificationReceived, notificationOpened)
    this.oneSignal.handleNotificationReceived().subscribe((data) => {
      // Handle received notifications if needed
      console.log('Notification received:', data);
    });

    this.oneSignal.handleNotificationOpened().subscribe((data) => {
      // Handle opened notifications if needed
      console.log('Notification opened:', data);
    });

    // Complete OneSignal initialization
    this.oneSignal.endInit();

    // Get device token
    this.oneSignal.getIds().then((token) => {
      this.testString = "token => " + token;
      this.util.teststring = "token.pushToken => " + token.pushToken + "token.userId => " + token.userId;
      if (token?.userId) {
        localStorage.setItem("pushToken", token.pushToken);
        localStorage.setItem("deviceToken", token.userId);
      }
    }).catch(error => {
      this.testString += "read output from onesignal (1234567890) coing to error section saying  => " + error;

      //console.error("Error retrieving OneSignal IDs:", error);
      localStorage.setItem("deviceToken", "Error-retrieving-OneSignal-IDs:" + error);
      // this.api.addOneSignalReq(this.testString);
    });
    // this.api.addOneSignalReq(this.testString);
    localStorage.setItem("onesignaloutput", this.testString);
  }

  async showToast() {
    const toast = await this.toastController.create({
      message: "Press back again to exit App.",
      duration: 2000,
    });
    toast.present();
  }
}
